import { Component, computed } from 'vue'
import { defineStore } from 'pinia'
import { getAccountLink, getOrdersLink } from '../useLinks'
import { useInvestmentProcessDataState } from '../investment-process/useInvestmentProcess'
import { getPendingInvestmentCookie } from '../investment-process/usePendingInvestmentProcess'
import { getCampaignData } from '../investment-process/useCampaign'

export interface InvestmentStep {
    name: string
    label: string
    component: Component
}

export const useInvestmentProcessNavigation = defineStore('investment-process-navigation', {
    state: () => {
        return {
            pageKey: null,
            steps: [] as InvestmentStep[],
        }
    },
    getters: {
        currentStep: (state) => {
            return state.steps.find((step) => step.name === state.pageKey)
        },
        currentStepIndex: (state) => {
            const stepIndex = state.steps.findIndex((step) => step.name === state.pageKey)
            if (stepIndex < 0) {
                return 0
            }
            return stepIndex
        },
    },
})

export const currentStep = computed((): InvestmentStep => {
    const state = useInvestmentProcessNavigation()
    return state.steps.find((step) => step.name === state.pageKey.value)
})

export function initializeInvestmentProcessNavigation(steps: InvestmentStep[]) {
    const investmentProcessNavigation = useInvestmentProcessNavigation()
    investmentProcessNavigation.steps = steps

    if (
        getPendingInvestmentCookie() &&
        getPendingInvestmentCookie().asset_uid === getCampaignData().asset_data.asset_uid
    ) {
        investmentProcessNavigation.pageKey = steps[getPendingInvestmentCookie().step].name
    } else {
        useInvestmentProcessDataState().setPendingInvestment()
        useInvestmentProcessDataState().saveBasket(1)
        investmentProcessNavigation.pageKey = steps[0].name
    }
}

export function navigateToNextStep() {
    const state = useInvestmentProcessNavigation()
    const currentStepIndex = state.steps.findIndex((step) => step.name === state.pageKey)
    if (currentStepIndex < state.steps.length - 1) {
        state.pageKey = state.steps[currentStepIndex + 1].name
    }

    if (currentStepIndex <= 1) {
        useInvestmentProcessDataState().setPendingInvestment()
        useInvestmentProcessDataState().saveBasket(currentStepIndex + 2)
    }
}

export function navigateToPreviousStep() {
    const state = useInvestmentProcessNavigation()
    const currentStepIndex = state.steps.findIndex((step) => step.name === state.pageKey)
    if (currentStepIndex >= 0) {
        state.pageKey = state.steps[currentStepIndex - 1].name
    }
    useInvestmentProcessDataState().setPendingInvestment()
    useInvestmentProcessDataState().saveBasket(currentStepIndex)
}

export function editPersonalData() {
    window.location = getAccountLink() + '?menu=Personal+Data'
}

export function editAddressData() {
    window.location = getAccountLink() + '?menu=Address+Data'
}

export function editCompanyData() {
    window.location = getAccountLink() + '?menu=Company+Data'
}

export function navigateToLandingPage() {
    window.location = '/'
}

export function navigateToOrders() {
    window.location = getOrdersLink()
}
